// extracted by mini-css-extract-plugin
export default {"details":"details_details__betZd"};